// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YhX7","fullView":"styles_fullView__26RDB"};